import React from 'react'
import { connect } from 'react-redux'
import { doGetSysService, doSaveSysService, doDeleteSysService } from '../../reducers/actions'

class SysServiceDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    const { onClose, dispatch, id } = this.props
    dispatch(doGetSysService({
      id,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }

  handlerConfirm = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const { onSave, onClose, dispatch } = this.props
    dispatch(doSaveSysService({
      id,
      changedValues基本信息,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))
  }

  handlerDelete = () => {
    const { id } = this.state
    const { onSave, onClose, dispatch } = this.props
    Tyan.pubForm.showConfirm('确定要删除？', () =>
      dispatch(doDeleteSysService({
        id,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
          }
          else {
            Ext.toast('删除成功')
            onSave && onSave()
            onClose && onClose()
          }
        }
      })))
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  canSave = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return Object.keys(changedValues基本信息).length > 0 && values.名称 && values.状态 
  }

  fieldset基本信息 = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return [
      { _text: '名称', required:true, name: '名称', minWidth: '400px', disabled: id > 0 && values.类型 == 1 },
      { _select: '状态', required:true, name: '状态', options: ['活动', '不活动'], editable: false, minWidth: '400px', },
      { _number: '运行间隔', name: '最小运行间隔', minWidth: '435px' },
      { _text: '运行时间', name: '每天运行时间', minWidth: '250px' },
      { _select: '', name: '每周运行时间', options: ['不限', '工作日', '节假日'], editable: false, minWidth: '80px', },
      { _text: '运行条件', name: '运行条件表达式', minWidth: '800px' },
      { _text: '运行参数', name: '运行参数', minWidth: '800px', maxRows: 8 },
    ]
  }

  render() {
    const { showMessage: Message, showBody: Body, id } = this.props
    const { initValues基本信息, changedValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />
    const canSave = this.canSave()
    return <Body data={this} maxWidth="1000"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
          { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && initValues基本信息.类型 == 2, handler: this.handlerDelete },
          { _button: '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(SysServiceDiv)